import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | MODALITY] Get Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | MODALITY] Get Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | MODALITY] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | MODALITY] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | MODALITY] Add Entity',
  UpdateEntity = '[STORE | ENTITY | MODALITY] Update Entity',
  RemoveEntity = '[STORE | ENTITY | MODALITY] Remove Entity',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.ModalityEntityModels.Modality> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.ModalityEntityModels.Modality> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.ModalityEntityModels.Modality> {
  public static readonly type = ActionTypes.RemoveEntity;
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>